<template>
  <div class="pack_menu_list">
    <!-- <div class="pack_menu" :class="{ active: showCardType == -1 }" @click="selectPackType(-1)">Twitter</div> -->
    <div class="pack_menu" :class="{ active: showCardType == -2 }" @click="selectPackType(-2)">How to play</div>
    <div class="pack_menu" :class="{ active: showCardType == -1 }" @click="selectPackType(-1)">
      Everyone's Record
    </div>
    <!-- <div class="pack_menu" :class="{ active: showCardType == 1 }" @click="selectPackType(1)">Yu-Gi-Oh!</div> -->
    <div class="pack_menu" :class="{ active: showCardType == 2 }" @click="selectPackType(2)">Pokémon</div>
    <!-- <div class="pack_menu" :class="{ active: showCardType == 3 }" @click="selectPackType(3)">Weiß<br>Schwarz</div> -->
    <!-- <div class="pack_menu" :class="{active: showCardType == 4}" @click="selectPackType(4)">SHADOW<br>VERSE</div> -->
    <!-- <div class="pack_menu" :class="{active: showCardType == 6}" @click="selectPackType(6)">Duel<br>Masters</div> -->
    <div class="pack_menu" :class="{ active: showCardType == 5 }" @click="selectPackType(5)">ONE PIECE</div>
    <div class="pack_menu" :class="{ active: showCardType == 11 }" @click="selectPackType(11)">DragonBall</div>
    <div class="pack_menu" :class="{ active: showCardType == 999996 }" @click="selectPackType(999996)">Other</div>
    <!-- <div class="pack_menu" :class="{active: showCardType == 9}" @click="selectPackType(9)">MTG</div> -->
    <!-- <div class="pack_menu" :class="{active: showCardType == 7}" @click="selectPackType(7)">figures</div> -->
    <!-- <div class="pack_menu" :class="{active: showCardType == 8}" @click="selectPackType(8)">Video<br>games</div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      showCardType: 'pack/topCardType',
    }),
  },
  methods: {
    selectPackType(type) {
      this.$store.dispatch('pack/setTopCardType', type);
    },
  },
};
</script>

<style lang="scss" scoped>
.pack_menu_list {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafafa;
  height: 70px;
  margin: 20px 0;
  width: 100vw;
  overflow-x: auto;
  @media screen and  (max-width: $tabletWidth) {
    flex-wrap: wrap;
    height: 100px;
  }

  .pack_menu {
    color: $mainColor;
    width: 126px;
    min-width: 126px;
    height: 100%;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: .4s;
    position: relative;
    margin: 0 1px;
    box-shadow: -1px 0px 1px 1px rgba(200, 200, 200, 0.5), 0px -1px 0px 1px rgba(200, 200, 200, 0.5);

    &:hover {
      background-color: #DDE6FF;
    }

    &.active {
      background-color: #DDE6FF;
    }
    @media screen and  (max-width: $tabletWidth) {
      height: 50px;
    }
  }
}
</style>
